module.exports = __webpack_public_path__ + "img/brand5.666c413b.png";